//人事申请类型 1:离职、2:转正、3:调动
export enum StaffApplyType {
  Resign = 1, //离职
  Regular = 2, //转正
  Transfer = 3, //调动
  CollectInfo = 4, //HR发起信息采集
}

export const StaffApplyTypeText = {
  [StaffApplyType.Resign]: '离职',
  [StaffApplyType.Regular]: '转正',
  [StaffApplyType.Transfer]: '调动',
  [StaffApplyType.CollectInfo]: 'HR发起信息采集',
};

//离职原因
export enum ResignReason {
  BetterOpportunity = 1, //个人辞职：找到更好机会
  LowSalary = 2, //个人辞职：工资低/公司福利不好
  LimitedDevelopment = 3, //个人辞职：个人职业发展受限
  NoConfidence = 4, //个人辞职：对公司发展前景不看好
  LeaveCity = 5, //个人辞职：离开工作城市/回老家
  StartBusiness = 6, //个人辞职：创业
  ContinueStudy = 7, //个人辞职：继续深造
  MutualAgreement = 8, //双方协商一致解除劳动合同
}

export const ResignReasonText = {
  [ResignReason.BetterOpportunity]: '个人辞职：找到更好机会',
  [ResignReason.LowSalary]: '个人辞职：工资低/公司福利不好',
  [ResignReason.LimitedDevelopment]: '个人辞职：个人职业发展受限',
  [ResignReason.NoConfidence]: '个人辞职：对公司发展前景不看好',
  [ResignReason.LeaveCity]: '个人辞职：离开工作城市/回老家',
  [ResignReason.StartBusiness]: '个人辞职：创业',
  [ResignReason.ContinueStudy]: '个人辞职：继续深造',
  [ResignReason.MutualAgreement]: '双方协商一致解除劳动合同',
};

//离职类型 1:主动离职、2:被动离职
export enum ResignType {
  Active = 1, //主动离职
  Passive = 2, //被动离职
}
export const ResignTypeText = {
  [ResignType.Active]: '主动离职',
  [ResignType.Passive]: '被动离职',
};

//审批状态 1:审批中、2:已通过、3:未通过、4:已驳回、5:无需审批
export enum StaffApprovalStatus {
  NotApply = 0, // 未申请
  WaitApprove = 1, //审批中
  Pass = 2, //已通过
  Refuse = 3, //未通过
  Reject = 4, //已驳回
  NoNeed = 5, //无需审批
  Cancel = 6, // 已取消
}
export const StaffApprovalStatusText: Record<string, string> = {
  [StaffApprovalStatus.WaitApprove]: '审批中',
  [StaffApprovalStatus.Pass]: '已通过',
  [StaffApprovalStatus.Refuse]: '未通过',
  [StaffApprovalStatus.Reject]: '已驳回',
  [StaffApprovalStatus.NoNeed]: '无需审批',
  [StaffApprovalStatus.Cancel]: '已撤销',
};

export enum StaffApplySearchType {
  MyApply = 1, //我的申请
  MyAudit = 2, //我的审批
  AllApply = 3, //全部申请
}
//离职交接类型 1:本人离职交接 2:直属上级工作交接 3:IT支持交接 4:行政部工作交接 5:财务部交接 6:人力资源部交接
export enum ResignHandoverType {
  SelfHandover = 1, //本人离职交接
  LeaderHandover = 2, //直属上级工作交接
  ITHandover = 3, //IT支持交接
  AdminHandover = 4, //行政部工作交接
  FinanceHandover = 5, //财务部交接
  HRHandover = 6, //人力资源部交接
}
export const ResignHandoverTypeText = {
  [ResignHandoverType.SelfHandover]: '本人离职交接',
  [ResignHandoverType.LeaderHandover]: '直属上级工作交接',
  [ResignHandoverType.ITHandover]: 'IT支持交接',
  [ResignHandoverType.AdminHandover]: '行政部工作交接',
  [ResignHandoverType.FinanceHandover]: '财务部交接',
  [ResignHandoverType.HRHandover]: '人力资源部交接',
};
//审批状态：1：待审批，2：审批中，3：已通过，4：已拒绝，5：撤销中 6:撤销成功 7：撤销失败
export enum AuditStatus {
  Wait = 1,
  Doing = 2,
  Pass = 3,
  Reject = 4,
  Revoking = 5,
  RevokeSuccess = 6,
  RevokeFail = 7,
}
export const AuditStatusText = {
  [AuditStatus.Wait]: '待审批',
  [AuditStatus.Doing]: '审批中',
  [AuditStatus.Pass]: '已通过',
  [AuditStatus.Reject]: '已拒绝',
  [AuditStatus.Revoking]: '撤销中',
  [AuditStatus.RevokeSuccess]: '已撤销',
  [AuditStatus.RevokeFail]: '撤销失败',
};
export const LeaveAuditStatusText = {
  [AuditStatus.Doing]: '审批中',
  [AuditStatus.Pass]: '已通过',
  [AuditStatus.Reject]: '已拒绝',
  [AuditStatus.RevokeSuccess]: '已撤销',
};
// 调班申诉结果：1：待审批，2：已通过，3：已拒绝 4：已撤销
export enum ShiftAuditStatus {
  WaitApprove = 1,
  Pass = 2,
  Refuse = 3,
  Cancel = 4,
}
export const ShiftAuditStatusText = {
  [ShiftAuditStatus.WaitApprove]: '待审批',
  [ShiftAuditStatus.Pass]: '已通过',
  [ShiftAuditStatus.Refuse]: '已拒绝',
  [ShiftAuditStatus.Cancel]: '已撤销',
};

//审批节点审批结果：1：待审批，2：已通过，3：已拒绝
export enum AuditNodeStatus {
  Wait = 1,
  Doing = 2,
  Pass = 3,
  Reject = 4,
}
export const AuditNodeStatusText = {
  [AuditNodeStatus.Wait]: '待审批',
  [AuditNodeStatus.Pass]: '已通过',
  [AuditNodeStatus.Reject]: '已拒绝',
};
export enum AuditBusinessType {
  LEAVE = 'leave',
  OUT_OFFICIAL = 'out_official',
  OUT_BUSINESS = 'out_business',
  RESIGN = 'resign',
  // 在职信息采集
  Collect = 'collect',
  Regular = 'regular',
  // 调动
  Transfer = 'transfer',
  OVERTIME = 'overtime',
  // 招聘
  Recruit = 'recruit',
  // 薪资
  Salary = 'salary',
  // 调班
  Shift = 'shift',
}
export enum AuditBusinessCode {
  //出差
  OutBusiness = 'out_business',
  // 公出
  OutOfficial = 'out_official',
  //出差销假
  CancelOutBusiness = 'cancel_out_business',
  //公出销假
  CancelOutOfficial = 'cancel_out_official',
  //法定年假
  LegalAnnualLeave = 'legal_annual_leave',
  //福利年假
  WelfareLeave = 'welfare_leave',
  //事假
  CasualLeave = 'casual_leave',
  //病假
  SickLeave = 'sick_leave',
  //带薪病假
  PaidSickLeave = 'paid_sick_leave',
  //婚假
  MarriageLeave = 'marriage_leave',
  //产假
  MaternityLeave = 'maternity_leave',
  //流产假
  AbortionLeave = 'abortion_leave',
  //产检假
  PrenatalCheckLeave = 'prenatal_check_leave',
  //陪产假
  PaternityLeave = 'paternity_leave',
  //育儿假
  ChildcareLeave = 'childcare_leave',
  //丧假
  FuneralLeave = 'funeral_leave',
  //哺乳假
  BreastfeedingLeave = 'breastfeeding_leave',
  //销假
  CancelLeave = 'cancel_leave',
  //离职
  Resign = 'resign',
  // 在职信息采集
  Collect = 'collect',
  // 转正
  Regular = 'regular',
  //调动
  Transfer = 'transfer',
  // 加班
  Overtime = 'overtime',
  // 招聘
  Recruit = 'recruit',
  // 薪资
  Salary = 'salary',
  // 调班
  Shift = 'shift',
}
export const AuditBusinessCodeText = {
  [AuditBusinessCode.OutBusiness]: '出差',
  [AuditBusinessCode.OutOfficial]: '公出',
  [AuditBusinessCode.CancelOutBusiness]: '出差撤销',
  [AuditBusinessCode.CancelOutOfficial]: '公出撤销',
  [AuditBusinessCode.LegalAnnualLeave]: '法定年假',
  [AuditBusinessCode.WelfareLeave]: '福利年假',
  [AuditBusinessCode.CasualLeave]: '事假',
  [AuditBusinessCode.SickLeave]: '病假',
  [AuditBusinessCode.PaidSickLeave]: '带薪病假',
  [AuditBusinessCode.MarriageLeave]: '婚假',
  [AuditBusinessCode.MaternityLeave]: '产假',
  [AuditBusinessCode.AbortionLeave]: '流产假',
  [AuditBusinessCode.PrenatalCheckLeave]: '产检假',
  [AuditBusinessCode.PaternityLeave]: '陪产假',
  [AuditBusinessCode.ChildcareLeave]: '育儿假',
  [AuditBusinessCode.FuneralLeave]: '丧假',
  [AuditBusinessCode.BreastfeedingLeave]: '哺乳假',
  [AuditBusinessCode.CancelLeave]: '销假',
  [AuditBusinessCode.Resign]: '离职',
  [AuditBusinessCode.Collect]: '在职信息采集',
  [AuditBusinessCode.Regular]: '转正',
  [AuditBusinessCode.Transfer]: '调动',
  [AuditBusinessCode.Overtime]: '加班',
  [AuditBusinessCode.Recruit]: '招聘',
  [AuditBusinessCode.Salary]: '薪资',
  [AuditBusinessCode.Shift]: '调班',
};
export const LeaveBusinessCodeText = {
  [AuditBusinessCode.LegalAnnualLeave]: '法定年假',
  [AuditBusinessCode.WelfareLeave]: '福利年假',
  [AuditBusinessCode.CasualLeave]: '事假',
  [AuditBusinessCode.SickLeave]: '病假',
  [AuditBusinessCode.PaidSickLeave]: '带薪病假',
  [AuditBusinessCode.MarriageLeave]: '婚假',
  [AuditBusinessCode.MaternityLeave]: '产假',
  [AuditBusinessCode.AbortionLeave]: '流产假',
  [AuditBusinessCode.PrenatalCheckLeave]: '产检假',
  [AuditBusinessCode.PaternityLeave]: '陪产假',
  [AuditBusinessCode.ChildcareLeave]: '育儿假',
  [AuditBusinessCode.FuneralLeave]: '丧假',
  [AuditBusinessCode.BreastfeedingLeave]: '哺乳假',
  [AuditBusinessCode.CancelLeave]: '销假',
};
export const LeaveApplyBusinessCodeText = {
  [AuditBusinessCode.LegalAnnualLeave]: '法定年假',
  [AuditBusinessCode.WelfareLeave]: '福利年假',
  [AuditBusinessCode.CasualLeave]: '事假',
  [AuditBusinessCode.SickLeave]: '病假',
  [AuditBusinessCode.PaidSickLeave]: '带薪病假',
  [AuditBusinessCode.MarriageLeave]: '婚假',
  [AuditBusinessCode.MaternityLeave]: '产假',
  [AuditBusinessCode.AbortionLeave]: '流产假',
  [AuditBusinessCode.PrenatalCheckLeave]: '产检假',
  [AuditBusinessCode.PaternityLeave]: '陪产假',
  [AuditBusinessCode.ChildcareLeave]: '育儿假',
  [AuditBusinessCode.FuneralLeave]: '丧假',
  [AuditBusinessCode.BreastfeedingLeave]: '哺乳假',
};
//离职角色
export enum AuditNodeCircleCode {
  /** 前端定义的两个节点类型 */
  Start = 'start',
  End = 'end',
  ResignHrbp = 'resign_hrbp',
  ResignLeader = 'resign_leader',
  ResignDeptManager = 'resign_dept_manager',
  ResignHrManager = 'resign_hr_manager',
  SelfResign = 'self_resign',
  ResignWorkHandover = 'resign_work_handover', //离职工作交接人
  ResignJobHandover = 'resign_job_handover', //工作交接
  ResignAdminHrHandover = 'resign_admin_hr_handover', //行政及HR交接确认
  ResignLeaderHandover = 'resign_leader_handover', //离职直属上级交接人
  ResignItSupportHandover = 'resign_it_support_handover', //离职it支持交接人
  ResignAdminHandover = 'resign_admin_handover', //行政部交接确认
  ResignFinanceHandover = 'resign_finance_handover', //财务部离职交接确认
  ResignHrHandover = 'resign_hr_handover', //人力资源部离职交接确认
  ResignDeptManagerHandover = 'resign_dept_manager_handover', //部门负责人离职交接确认
  ResignLeaderLastConfirm = 'resign_leader_last_confirm', //直属上级离职交接最后确认
  ResignHrManagerHandover = 'resign_hr_manager_handover', //人力资源部负责人离职交接确认
  ResignProjectLeaderHandover = 'resign_project_leader_handover', //项目负责人离职交接确认
  ResignPrintHrManager = 'resign_print_hr_manager', //打印离职资料处理人
  RecruitHrManager = 'recruit_hr_manager', //招聘hr审批
  RecruitManager = 'recruit_manager', //部门负责人
  /** 在职采集 */
  CollectAccount = 'collect_account',
  CollectHr = 'collect_hr',
  ShiftChangeAccount = 'shift_change_account', // 被调班人确认调班

  /** 转正 */
  RegularAccount = 'regular_account',
  RegularLeader = 'regular_leader',
  RegularDeptManager = 'regular_dept_manager',
  RegularHrbp = 'regular_hrbp',
  RegularPerformanceHr = 'regular_performance_hr',
  RegularHrManager = 'regular_hr_manager',
  RegularProjectLeader = 'regular_project_leader', //项目负责人

  /** 调动 */
  TransferSourceHrbp = 'transfer_source_hrbp', //调出部门hrbp
  TransferSourceDeptManager = 'transfer_source_dept_manager', //调出部门负责人
  TransferTargetHrbp = 'transfer_target_hrbp', //调入部门hrbp
  TransferTargetDeptManager = 'transfer_target_dept_manager', //调入部门负责人
  TransferAccountConfirm = 'transfer_account_confirm', //员工确认
  TransferSourceProjectLeader = 'transfer_source_project_leader', //调出项目负责人

  /** 加班 */
  OvertimeHr = 'overtime_hr', //hr审批
  OvertimeManager = 'overtime_manager', //直属上级审批
}

export enum HandoverStatus {
  Finished = 1,
  None = 2,
}
export const HandoverStatusText = {
  [HandoverStatus.Finished]: '已办理',
  [HandoverStatus.None]: '无',
};
//审批通过类型 1:任意1审批1通过 2:全部审批1通过 3:全审批全通过
export enum ApprovePassType {
  AnyOnePass = 1, //任意1审批1通过
  AllOnePass = 2, //全部审批1通过
  AllPass = 3, //全审批全通过
}
export const ApprovePassTypeText = {
  [ApprovePassType.AnyOnePass]: '其中一人收到审批通知，审批同意即流转下一节点',
  [ApprovePassType.AllOnePass]:
    '多人均收到审批通知，任意一人审批同意即流转下一节点',
  [ApprovePassType.AllPass]: '按顺序依次收到审批通知，依次同意才流转下一节点',
};

export enum ResignCertificateReason {
  Resign = 1, //个人辞职，解除劳动合同
  ContractExpired = 2, //劳动合同期满，终止劳动合同
  TrialPeriod = 3, //终止试用
  MutualAgreement = 4, //双方协商一致解除劳动合同
  Other = 5, //其他
}
export const ResignCertificateReasonText = {
  [ResignCertificateReason.Resign]: '个人辞职，解除劳动合同',
  [ResignCertificateReason.ContractExpired]: '劳动合同期满，终止劳动合同',
  [ResignCertificateReason.TrialPeriod]: '终止试用',
  [ResignCertificateReason.MutualAgreement]: '双方协商一致解除劳动合同',
  [ResignCertificateReason.Other]: '其他',
};
/** 前加签，后加签 */
export enum AddSignType {
  Prev = 1,
  Next = 2,
}
export const AddSignTypeText = {
  [AddSignType.Prev]: '前加签',
  [AddSignType.Next]: '后加签',
};
//附件提交审批状态 1:待审批 2:审批中 3:审批通过 4:审批拒绝
export enum AuditAttachmentStatus {
  Wait = 1,
  Doing = 2,
  Pass = 3,
  Reject = 4,
}
export const AuditAttachmentStatusText = {
  [AuditAttachmentStatus.Wait]: '待审批',
  [AuditAttachmentStatus.Doing]: '审批中',
  [AuditAttachmentStatus.Pass]: '审批通过',
  [AuditAttachmentStatus.Reject]: '审批拒绝',
};
//在职信息采集状态 1:待审批 2:审批中 3:审批通过 4:审批拒绝 5:已撤销
export enum CollectInfoStatus {
  WaitApprove = 1, //待审批
  Doing = 2, //审批中
  Pass = 3, //审批通过
  Refuse = 4, //审批拒绝
  Cancel = 5, //已撤销
}
export const CollectInfoStatusText = {
  [CollectInfoStatus.WaitApprove]: '--',
  [CollectInfoStatus.Doing]: '审批中',
  [CollectInfoStatus.Pass]: '已通过',
  [CollectInfoStatus.Refuse]: '已拒绝',
  [CollectInfoStatus.Cancel]: '已撤销',
};
//转正结果 1：提前转正、2：正常转正、3：延期转正
export enum RegularResult {
  Early = 1, //提前转正
  Normal = 2, //正常转正
  Delayed = 3, //延期转正
}
export const RegularResultText = {
  [RegularResult.Early]: '提前转正',
  [RegularResult.Normal]: '正常转正',
  [RegularResult.Delayed]: '延期转正',
};
// 审批类型（1：串行，2：条件分支，3：结束，4：并行网关）
// Parallel 是历史命名，type=2 表示条件分支（只走一条），不是并行
export enum AuditType {
  Serial = 1,
  Parallel = 2,
  End = 3,
  ParallelGateway = 4,
}
